import hasWebGL from './lib/hasWebGL';
import ShapeAnimation from './component/ShapeAnimation/ShapeAnimation';
import DecorativeShape from './component/DecorativeShape/DecorativeShape';

if (hasWebGL()) {
	ShapeAnimation.init();
	DecorativeShape.init();
}